import {
  ResourcesDisplayField,
} from 'core-app/shared/components/fields/display/field-types/resources-display-field.module';

export class AttachmentsDisplayField extends ResourcesDisplayField {
  public get stringValue():string[] {
    const cf = this.resource[this.name];
    if (this.schema && cf) {
      if (cf.elements) {
        return cf.elements.map((e:any) => e.$link.title);
      }
      if (cf.map) {
        return cf.map((e:any) => e.$link.title);
      }
      if (cf.name) {
        return [cf.name];
      }
      return [`error: ${JSON.stringify(cf)}`];
    }

    return [];
  }
}
